import { Flex } from '@chakra-ui/layout';
import React, { useCallback, useState } from 'react';

import { AssignParties } from '~/core/routes/settings/implementations/create/AssignParties';
import { ChooseOrganizations } from '~/core/routes/settings/implementations/create/ChooseOrganizations';
import { NameImplementation } from '~/core/routes/settings/implementations/create/NameImplementation';

export type WizardComponent = React.FC<{
  previousStep: () => void;
  nextStep: () => void;
  selectedOrgs: Org[];
  setSelectedOrgs: React.Dispatch<React.SetStateAction<Org[]>>;
  implementationName: string;
  setImplementationName: React.Dispatch<React.SetStateAction<string>>;
}>;

export type PartyType =
  | 'borrower'
  | 'capitalProvider'
  // | 'lenderAdministrativeAgent' // BE doesn't yet support these partyTypes, but they will come later.
  // | 'administrativeAgent'
  | 'servicer'
  | 'verificationAgent';

export type Org = {
  name: string;
  id: string;
  type?: PartyType;
};

const WIZARD_STEPS: WizardComponent[] = [
  ChooseOrganizations,
  AssignParties,
  NameImplementation,
];

export const ImplementationWizard = () => {
  const [step, setStep] = useState(0);
  const [selectedOrgs, setSelectedOrgs] = useState<Org[]>([]);
  const [implementationName, setImplementationName] = useState('');

  const previousStep = useCallback(
    () => setStep((prevStep) => prevStep - 1),
    [],
  );
  const nextStep = useCallback(() => setStep((prevStep) => prevStep + 1), []);

  const CurrentWizardComponent = WIZARD_STEPS[step];

  return (
    <Flex
      width={{ base: '100%', lg: '56rem' }}
      direction="column"
      alignSelf="center"
    >
      <CurrentWizardComponent
        previousStep={previousStep}
        nextStep={nextStep}
        selectedOrgs={selectedOrgs}
        setSelectedOrgs={setSelectedOrgs}
        implementationName={implementationName}
        setImplementationName={setImplementationName}
      />
    </Flex>
  );
};
